import { OptionItem } from "./option-item";

export class EmployerDetails {
  name: string = '';
  abn: string = '';
  firstName: string = '';
  surname: string = '';
  email: string = '';
  phoneType: OptionItem | null = null;
  phoneCountryCode: string = '';
  phoneAreaCode: string = '';
  phoneNumber: string = '';
  jobTitle: string = '';
  salary: string = '';
  hasOffer: string = '';
  canContact: string = '';
  investedTraining: string = '';
  startTrading: string = '';
  ausStaff: string = '';
  address1: string = '';
  address2: string = '';
  suburb: string = '';
  city: string = '';
  postcode: string = '';
  state: string = '';
  country: string = '';
}